import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

import api from '@/lib/api'

interface UpdateParams {
  id_apuracao: string
  competencia: string
  valor: number
}

export function useUpdateRestituicaoSimples() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ id_apuracao, competencia, valor }: UpdateParams) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const body = {
        id_apuracao: id_apuracao || '',
        competencia: competencia || '',
        valor: valor || ''
      }

      const response = await api.patch(`/simples/update`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data
      } else {
        throw new Error('Erro ao atualizar valor do total')
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productSenha'] })
    }
  })
}
